import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ButtonItem from '../components/ButtonItem';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

function ClientViewPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const [clients, setClients] = useState([]);

  const params = new URLSearchParams(location.search);
  const page = params.get('page');
  const search = params.get('search');


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/client/${id}`
        );
        setClients(response.data);
      } catch (error) {
        console.error('서버 접속 에러:', error);
      }
    };
    fetchData();
  }, [id]);

  const deleteClient = async () => {
    if (window.confirm('권리사를 삭제하시겠습니까?')) {
      try {
        await axios.delete(`${process.env.REACT_APP_API_URL}/client/${id}`);
        if (window.confirm('권리사를 삭제하였습니다.')) {
          window.location.href = '/Clients';
        }
      } catch (error) {
        console.error('서버 접속 에러:', error);
      }
    }
  };

  return (
    <>
        <div className="flex mb-8 justify-center items-center">
          <div className="text-xl sm:text-2xl font-bold text-white tracking-tight">
            <span>권리사 상세정보</span>
          </div>
        </div>

        <div className="flex justify-center">
          <div className="space-y-6">
            <div>
              <label className="block font-semibold mb-1">권리사명</label>
              <input
                type="text"
                value={clients.name || ''}
                className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-white/[0.03] text-slate-300 focus:outline-none"
                readOnly
              />
            </div>

            <div>
              <label className="block font-semibold mb-1">아이디</label>
              <input
                type="text"
                value={clients.loginId || ''}
                className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-white/[0.03] text-slate-300 focus:outline-none"
                readOnly
              />
            </div>

            <div>
              <label className="block font-semibold mb-1">전화번호</label>
              <div className="flex gap-2">
                <input
                  type="text"
                  value={clients.phone1 || ''}
                  className="w-1/4 px-3 py-2 rounded-xl border border-white/[0.08] bg-white/[0.03] text-slate-300 focus:outline-none"
                  readOnly
                />
                <span className="self-center">-</span>
                <input
                  type="text"
                  value={clients.phone2 || ''}
                  className="w-1/4 px-3 py-2 rounded-xl border border-white/[0.08] bg-white/[0.03] text-slate-300 focus:outline-none"
                  readOnly
                />
                <span className="self-center">-</span>
                <input
                  type="text"
                  value={clients.phone3 || ''}
                  className="w-1/4 px-3 py-2 rounded-xl border border-white/[0.08] bg-white/[0.03] text-slate-300 focus:outline-none"
                  readOnly
                />
              </div>
            </div>

            <div>
              <label className="block font-semibold mb-1">이메일</label>
              <div className="flex items-center gap-2">
                <input
                  type="text"
                  value={clients.emailId || ''}
                  className="w-1/3 px-3 py-2 rounded-xl border border-white/[0.08] bg-white/[0.03] text-slate-300 focus:outline-none"
                  readOnly
                />
                <span>@</span>
                <input
                  type="text"
                  value={clients.emailDomain || ''}
                  className="w-1/3 px-3 py-2 rounded-xl border border-white/[0.08] bg-white/[0.03] text-slate-300 focus:outline-none"
                  readOnly
                />
              </div>
            </div>

            <div className="relative">
              <label className="block font-semibold mb-1">주소</label>
              <div className="flex gap-2">
                <input
                  type="text"
                  value={clients.zonecode || ''}
                  className="w-1/4 px-3 py-2 rounded-xl border border-white/[0.08] bg-white/[0.03] text-slate-300 focus:outline-none"
                  readOnly
                />
                <input
                  type="text"
                  value={clients.address || ''}
                  className="flex-1 px-3 py-2 rounded-xl border border-white/[0.08] bg-white/[0.03] text-slate-300 focus:outline-none"
                  readOnly
                />
              </div>
              <input
                type="text"
                value={clients.detailAddress || ''}
                className="w-full px-3 py-2 rounded-xl border border-white/[0.08] mt-2 bg-white/[0.03] text-slate-300 focus:outline-none"
                readOnly
              />
            </div>

            <div>
              <label className="block font-semibold mb-1">유형</label>
              <div className="flex gap-6">
                <label className="flex items-center gap-1">
                  <input
                    type="radio"
                    value="개인"
                    checked={clients.type === '개인'}
                    disabled={true}
                  />
                  <span>개인</span>
                </label>
                <label className="flex items-center gap-1">
                  <input
                    type="radio"
                    value="사업자"
                    checked={clients.type === '사업자'}
                    disabled={true}
                  />
                  <span>사업자</span>
                </label>
              </div>
            </div>

            <div>
              {clients.type === '개인' ? (
                <>
                  <label className="block font-semibold mb-1">
                    주민등록번호
                  </label>
                  <div className="flex items-center gap-2">
                    <input
                      type="text"
                      maxLength="6"
                      value={clients.rrn1 || ''}
                      className="w-1/3 px-3 py-2 rounded-xl border border-white/[0.08] bg-white/[0.03] text-slate-300 focus:outline-none"
                      readOnly
                    />
                    <span>-</span>
                    <input
                      type="text"
                      maxLength="7"
                      value={
                        clients.rrn2 ? '*'.repeat(clients.rrn2.length) : ''
                      }
                      className="w-1/3 px-3 py-2 rounded-xl border border-white/[0.08] bg-white/[0.03] text-slate-300 focus:outline-none"
                      readOnly
                    />
                  </div>
                </>
              ) : clients.type === '사업자' ? (
                <>
                  <label className="block font-semibold mb-1">
                    사업자등록번호
                  </label>
                  <div className="flex items-center gap-2">
                    <input
                      type="text"
                      maxLength="3"
                      value={clients.rrnA || ''}
                      className="w-1/4 px-3 py-2 rounded-xl border border-white/[0.08] bg-white/[0.03] text-slate-300 focus:outline-none"
                      readOnly
                    />
                    <span>-</span>
                    <input
                      type="text"
                      maxLength="2"
                      value={clients.rrnB || ''}
                      className="w-1/4 px-3 py-2 rounded-xl border border-white/[0.08] bg-white/[0.03] text-slate-300 focus:outline-none"
                      readOnly
                    />
                    <span>-</span>
                    <input
                      type="text"
                      maxLength="5"
                      value={clients.rrnC || ''}
                      className="w-1/4 px-3 py-2 rounded-xl border border-white/[0.08] bg-white/[0.03] text-slate-300 focus:outline-none"
                      readOnly
                    />
                  </div>
                </>
              ) : (
                <div></div>
              )}
            </div>

            <div>
              <label className="block font-semibold mb-1">은행 정보</label>
              <div className="flex gap-4">
                <input
                  type="text"
                  value={clients.bank || ''}
                  className="w-1/3 px-3 py-2 rounded-xl border border-white/[0.08] bg-white/[0.03] text-slate-300 focus:outline-none"
                  readOnly
                />
                <input
                  type="text"
                  value={clients.account || ''}
                  className="w-1/3 px-3 py-2 rounded-xl border border-white/[0.08] bg-white/[0.03] text-slate-300 focus:outline-none"
                  readOnly
                />
                <input
                  type="text"
                  value={clients.holder || ''}
                  className="w-1/3 px-3 py-2 rounded-xl border border-white/[0.08] bg-white/[0.03] text-slate-300 focus:outline-none"
                  readOnly
                />
              </div>
            </div>
          </div>
        </div>

        <div className="w-full flex justify-end items-center mt-5">
          <ButtonItem
            className="mr-2"
            text="목록"
            color="gray"
            onClick={() => {
              const searchParam = search ? `&search=${encodeURIComponent(search)}` : '';
              navigate(`/Clients?page=${page}${searchParam}`);
            }}
          />
          <ButtonItem
            className="mr-2"
            text="삭제"
            color="red"
            onClick={deleteClient}
          />
          <ButtonItem
            text="수정"
            color="blue"
            onClick={() => {
              const searchParam = search ? `&search=${encodeURIComponent(search)}` : '';
              navigate(`/Clients/Modify/${id}?page=${page}${searchParam}`);
            }}
          />
        </div>
    </>
  );
}

export default ClientViewPage;
